export default __webpack_public_path__ + "static/media/1979.1d123a11.png";